import { createContext } from "react";

/**
 * Whether a voice session is active, for code that also runs OUTSIDE the Learn stack. There, no
 * session can exist, so `false` is the true answer rather than a stand-in for a missing provider.
 * Provided by `VoiceStudyProvider`; read through `useVoiceStudyEnabledIfProvided()`.
 */
export const VoiceStudyEnabledIfProvidedContext = createContext(false);
